export const whiteLabelKeys = {
  white_label: () => ['WHITE_LABEL'] as const,
};
